// src/features/audit/components/AuditHeader.tsx
import { PageHeader } from '../../../app/components/foundation';

/**
 * Page-top header for Audit Foundation. Reuses the shared PageHeader
 * primitive (same contract every other feature's header uses) and
 * puts one disabled placeholder in the actions slot to reserve visual
 * space for a future "خروجی گزارش" action. It has no click handler
 * and does nothing yet — wiring it to a real export flow is a later
 * phase, not this one. Same pattern as
 * security/components/SecurityHeader.tsx and
 * commission/components/CommissionHeader.tsx.
 */
export function AuditHeader() {
  return (
    <PageHeader
      title="گزارش رخدادها"
      description="مشاهده رخدادهای امنیتی و عملیاتی ثبت‌شده در پلتفرم."
      actions={
        <button
          type="button"
          disabled
          className="vania-audit-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          خروجی گزارش
        </button>
      }
    />
  );
}
